import React from 'react';
import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faArrowDown } from '@fortawesome/free-solid-svg-icons';

class Holidays extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(),
      cutOffTime: '',
      caseTurnAround: '',
      pickupInstructions: '',
      shipNextDay: false,
      days: {
        Monday: true,
        Tuesday: true,
        Wednesday: true,
        Thursday:true,
        Friday: true,
        Saturday: false,
        Sunday: false
      }
    };
  }

  handleDateChange = date => {
    this.setState({
      startDate: date
    });
  };

  handleInputChange = (event) => {
    const { name, checked } = event.target;
    this.setState(prevState => ({
      days: {
        ...prevState.days,
        [name]: checked
      }
    }));
  }

  render() {
    return (
            <div style={{background: '#f0f0f5' }}>
              <h1 className="title" style={{ color: 'black' }}>Scheduling and Holidays</h1>
              <div className="bg-primary text-white" style={{ padding: '10px', borderRadius: '5px' }}>
                <h3>Work Days</h3>
              </div>
              <br/>
              <div className="search" style={{ border: 'white', borderTop: '3px solid #004aad', padding: '10px' }}>
                {Object.keys(this.state.days).map((day, index) => (
                  <div key={index} style={{ marginBottom: '10px' }}>
                    <label style={{ display: 'inline-block', marginLeft: '15%' }}>
                      <input
                        name={day}
                        type="checkbox"
                        checked={this.state.days[day]}
                        onChange={this.handleInputChange}
                        style={{ marginLeft: '10px', marginRight:'10px' }}
                      />
                      {day}
                    </label>
                  </div>
                ))}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px',marginLeft:"10px" }}>
                <label style={{ marginRight: '80px' }}>
                  Cut Off Time:
                </label>
                <input 
                  type="text"
                  className="form-control"
                  style={{ width: '30%', padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}  
                  value={this.state.cutOffTime}
                  onChange={e => this.setState({ cutOffTime: e.target.value })}
                />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px',marginLeft:"10px"  }}>
                <label style={{ marginRight: '40px' }}>
                  Case Turn Around:
                </label>
                <input 
                  type="text"
                  className="form-control"
                  style={{ width: '30%', padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}  
                  value={this.state.caseTurnAround}
                  onChange={e => this.setState({ caseTurnAround: e.target.value })}
                />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px',marginLeft:"10px"  }}>
                <label style={{ marginRight: '25px' }}>
                  Pickup Instructions:
                </label>
                <div style={{ display: 'flex', alignItems: 'center', marginLeft: '10px' }}>
                  <input 
                    type="text"
                    className="form-control"
                    style={{ width: '70%', padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
                    value={this.state.pickupInstructions}
                    onChange={e => this.setState({ pickupInstructions: e.target.value })}
                  />
                  <button 
                    style={{ padding: '3px', border: '1px solid #ccc', borderRadius: '4px', marginLeft: '5px', fontSize: '12px' }}  
                    onClick={() => this.setState(prevState => ({ pickupInstructions: parseInt(prevState.pickupInstructions) + 1 || 1 }))}>
                    <FontAwesomeIcon icon={faArrowUp} size="sm" /> 
                  </button>
                  <button 
                    style={{ padding: '3px', border: '1px solid #ccc', borderRadius: '3px', marginLeft: '5px', fontSize: '12px' }}  
                    onClick={() => this.setState(prevState => ({ pickupInstructions: prevState.pickupInstructions > 0 ? prevState.pickupInstructions - 1 : 0 }))}>
                    <FontAwesomeIcon icon={faArrowDown} size="sm" /> 
                  </button>
                </div>
              </div>
              <div style={{ marginBottom: '10px',marginLeft:"10px"  }}>
                <label style={{ display: 'inline-block', marginRight: '70px', }}>
                  Ship Next Day:
                </label>
                <input 
                  type="checkbox" 
                  checked={this.state.shipNextDay} 
                  onChange={e => this.setState({ shipNextDay: e.target.checked })}
                  style={{ marginRight: '5px' }}  
                />
              </div>
              <div>
                <div>
                  <h1 className="title" style={{ color: 'black' }}>Holidays</h1>
                </div>
                <div className="search" style={{ border: 'white', borderTop: '3px solid #004aad', padding: '10px' }}>
                  <label>Date</label>
                  <h7>You have no holidays defined. Add one</h7>
                  <div className='col-lg-3'>
                    <input type="date" className='form-control  mt-3' style={{textAlign:"center"}}/>
                  </div>
                </div>
              </div>
              {/* Submit Button */}
              <div style={{ textAlign: 'left', marginTop: '20px',marginLeft:"10px" }}>
                <button className="btn btn-primary"style={{backgroundColor:"#004aad",borderColor:"#004aad"}} onClick={this.handleSubmit}>Submit</button>
              </div>
              <br/>
            </div>
    );
  }
}

export default Holidays;
